export default __webpack_public_path__ + "static/media/screenShots_blash-1.440f14c8.jpg";